import ConverstionItem from "./ConverstionItem";
import { useState, useEffect } from "react";
import { ConversationProps } from "../../../typings/messages";
import { getConverstaionList } from "../../../services/messageService";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import ConverstaionLoader from "./ConverstaionLoader";
// import { useLocation } from 'react-router-dom';
import EmptyCarpetPlaceHolder from "../../../components/EmptyCarpetPlaceHolder";
import { setConversation } from "../../../redux/carpet";
import { NavLink, useLocation } from "react-router-dom";
import { HOMEPAGE } from "../../../navigation/Constants";

const ConverstaionList = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { memberCode: myMemberCode } = useSelector(
    (state: RootState) => state.member
  );
  const { conversation } = useSelector((state: RootState) => state.carpet);
  const [conversations, setConversations] = useState<ConversationProps[]>([]);
  const [searchResults, setSearchResults] = useState<ConversationProps[]>([]);
  const [search, setSearch] = useState<string>("");
  const dispatch = useDispatch();
  const location = useLocation();

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   getData();

  //   document.addEventListener("refresh-conversation-list", () => {
  //     getData();
  //   });
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, [location]);

  useEffect(() => {
    const handleRefreshEvent = () => {
      getData();
    };

    document.addEventListener("refresh-conversation-list", handleRefreshEvent);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener(
        "refresh-conversation-list",
        handleRefreshEvent
      );
    };
  }, []);

  useEffect(() => {
    setConversations(conversation);
    handleSearch();
  }, [conversation]);

  const getData = async () => {
    setIsLoading(true);
    const { data } = await getConverstaionList(myMemberCode);
    dispatch(setConversation(data));
    setConversations(data);
    setSearchResults(data);
    setIsLoading(false);
  };

  const handleSearch = () => {
    const q = search.trim();
    if (!q) {
      setSearchResults(conversations);
    } else {
      const regex = new RegExp(q, "i");
      setSearchResults(
        conversations.filter((user) => regex.test(user.userName))
      );
    }
  };

  useEffect(() => {
    handleSearch();
  }, [search]);

  return (
    <>
      <div className="top_sec wf-section">
        <NavLink className="top_logo_bounakir w-inline-block" to={HOMEPAGE}>
          <img src="assets/images/shoshke_logo.svg" loading="lazy" />
        </NavLink>
        <div className="top_content messages w-clearfix">
          <h1 className="top_title messages">שיחות אחרונות</h1>
        </div>
      </div>

      {isLoading ? (
        <ConverstaionLoader />
      ) : conversations ? (
        <div className="content_sec full wf-section">
          <div className="content_block">
            <div className="messages_search w-form">
              <input
                autoComplete="off"
                type="text"
                className="messages_field w-input"
                maxLength={256}
                placeholder="חיפוש"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div
                className="massage_field_ic"
                onClick={() => setSearch("")}
                style={search ? { cursor: "pointer" } : {}}
              >
                <img
                  src={
                    search
                      ? "/assets/images/ic_search_close.svg"
                      : "/assets/images/ic_search.svg"
                  }
                  loading="lazy"
                  alt=""
                />
              </div>
            </div>

            {conversations.length > 0 ? (
              <ul className="messages_list w-list-unstyled">
                {searchResults.length > 0 ? (
                  searchResults.map((conversation, index) => {
                    return (
                      <ConverstionItem
                        key={index}
                        lastMessage={conversation.lastMessage}
                        memberCode={conversation.memberCode}
                        memberName={conversation.memberName}
                        userName={conversation.userName}
                        messageTypeId={conversation.messageTypeId}
                        newMessagesCount={conversation.newMessagesCount}
                        memberImageUrl={conversation.memberImageUrl}
                        lastMessageBy={conversation.lastMessageBy ?? null}
                        firstSenderMemberCode={
                          conversation?.firstSenderMemberCode
                        }
                        stickerId={conversation?.stickerId}
                        stickerImageUrl={conversation?.stickerImageUrl}
                      />
                    );
                  })
                ) : (
                  <div style={{ textAlign: "center", marginTop: "30px" }}>
                    לא נמצאו תוצאות חיפוש{" "}
                  </div>
                )}
              </ul>
            ) : (
              <div>
                <EmptyCarpetPlaceHolder
                  imgSrc={"/assets/images/no-results-chats.svg"}
                  title={"עדיין אין הודעות בתיבה"}
                  subTitle={
                    "איך מתחילים להתכתב? שולחים הצעת היכרות לחברים בקהילה.  כשהם יאשרו את הבקשה, אפשר יהיה להתחיל להתכתב ולקחת את ההיכרות הלאה"
                  }
                  showHelpLink={true}
                />
              </div>
            )}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ConverstaionList;
